module.exports = __webpack_public_path__ + "img/title1.e3330ae5.png";